'use client'

import { memo, useMemo } from 'react'
import { checkoutAvailablePaymentMethodsSelector } from '@segway/core'
import { useAppSelector } from '@segway/core/src/store/hooks'

import { PaymentMethods } from '../paymentMethods'

/**
 * Regular order payment methods component
 */
const RegularPaymentMethods = () => {
  const checkoutAvailablePaymentMethods = useAppSelector(checkoutAvailablePaymentMethodsSelector)

  const methods = useMemo(() => {
    return checkoutAvailablePaymentMethods?.map((method) => {
      return {
        code: method?.code ?? '',
        title: method?.title ?? '',
      }
    })
  }, [checkoutAvailablePaymentMethods])

  return <PaymentMethods methods={methods} />
}

export default memo(RegularPaymentMethods)
